<div class="container">
  <div class="question">{{ chatService.triviaRain?.current?.question }}</div>
  <div class="options">
    @for (option of chatService.triviaRain.current.options; track option) {
    <button
      class="option"
      (click)="selectOption(option)"
      [class.selected]="option.selected && chatService.triviaRain.status === 'running'"
      [class.correct]="
        chatService.triviaRain.current?.winningOption?.hash === option.hash && (chatService.triviaRain.status === 'failed' || chatService.triviaRain.status === 'ended')
      "
      [class.wrong]="
        chatService.triviaRain.current?.winningOption?.hash !== option.hash && (chatService.triviaRain.status === 'failed' || chatService.triviaRain.status === 'ended')
      "
      [class.hover]="chatService.triviaRain.status === 'running'"
    >
      {{ option.text }}
    </button>
    }
  </div>
  <div class="info">
    <span class="amount">
      <app-icon icon="coin" />
      <app-currency [value]="chatService.triviaRain.current.amount" [size]="14"></app-currency>
    </span>
    <span class="user">
      <img class="avatar" [ngSrc]="chatService.triviaRain.current.avatar" width="15" height="15" />
      {{ chatService.triviaRain.current.by | name }}
    </span>
  </div>
</div>
